module.exports = __webpack_public_path__ + "img/01.8bea32a9.png";